<template>
  <div>
    <Breadcrumbs :breadcrumbs="[
      {title: this.$t('user.support_hub'), disabled: true},
    ]"/>

    <va-button
    @click="handleRedirect('https://forms.office.com/pages/responsepage.aspx?id=SH76OEbl9kW-IUIgIj0eWrOgrw2LK3hMtwUI6qYcFJJUOUlHVTFISVpCVDlaT1JBNjY2QVNKRFdWVS4u')">
      Suporte Desenvolvimento
    </va-button>

    <va-button
    @click="handleRedirect('https://forms.office.com/Pages/ResponsePage.aspx?id=SH76OEbl9kW-IUIgIj0eWmLry-dEgqhMnXlwUOdDd4FUOFlLSlUySUlTVEdVTktKR0xGREdEWUVYWC4u')">
      Suporte Marketing
    </va-button>
    <!--<div class="pt-5">
      <div id="reportContainer">
        <span class="i-evollu-black"></span>
        <hr class="ml-4 mr-4"></hr>



        <div class="row col-12">
          <div class="card mr-2 col-4">
            <h4 class="black-h4">
              Check-Up Plus Individual Report
            </h4>
            <div>
          <span>
            This report presents the results of Evollu Check-Up Plus consultation
          </span>
              <p />
              <span class="is-bold">
                Consultation Date
              </span>
              <br/>
              <span>
            29/12/2023
          </span>
            </div>

          </div>

          <div class="card mr-2 col-4">
            <h4 class="black-h4">
              Patient Details
            </h4>
            <div>
              <div class="row col-12">
                <div class="col-8 pl-0">
                  <span class="is-bold">
                    Name
                  </span>
                  <br/>
                  <span>
                    Carlos Ferreira Pereira Santos
                  </span>
                </div>
                <div class="col-4 pl-0">
                  <span class="is-bold">
                    Date of Birth
                  </span>
                  <br/>
                  <span>
                    29/12/1975
                  </span>
                </div>
              </div>
              <div class="row col-12 mt-2">
                <span class="is-bold">
                  Address
                </span>
                <br/>
                <span>
                    Rua Doutor Ilidio Amado, 2500-910, Leiria
                </span>
              </div>

            </div>

          </div>

          <div class="card col-4">
            <h4 class="black-h4">
              Pharmacy Details
            </h4>

            <div>
              <div class="row col-12 mt-2 flex-column">
                <span class="is-bold">
                  Entity
                </span>
                <span>
                    Farmácia XPTO, Leiria
                </span>
              </div>
              <div class="row col-12 mt-2 flex-column">
                <span class="is-bold">
                  Instalation
                </span>
                <span>
                    Farmácia XPTO, Leiria
                </span>
              </div>
            </div>

          </div>
        </div>

        <div class="col-12 bio-params mt-5 pt-3 pb-3">
          <span class="fa fa-medkit" style="font-size: 24px"></span>
          &ensp;<span class="is-bold" style="font-size: 20px; color: rgba(71,73,71,0.88)">Biometric Parameters</span>
          <br/>
          <p>
            RESULTS RESULTS RESULTS RESULTS RESULTS RESULTS RESUTLS
          </p>
        </div>

        <div class="col-12 mt-5">
          <h4 class="black-h4">
            Blood Pressure
          </h4>
          <span class="is-bold">LAST MEASUREMENT ON 29-dez-2023 10:40</span>

          <div class="row col-12 mt-2">
            <div class="card-measurement card mr-2 col-4">
              <div>
                <span class="fa fa-heart-o" style="font-weight: bold; font-size: 24px"> </span>
                &ensp;<span class="is-bold" style="font-size: 20px">Systolic</span>
              </div>
              <div class="row col-12 mt-2 flex-column">
                <span class="is-bold">
                  123mm Hg
                </span>
                <span>
                    123 mm Hg on the last test
                </span>
              </div>


            </div>

            <div class="card-measurement card mr-2 col-4">
              <div>
                <span class="fa fa-heart-o" style="font-weight: bold; font-size: 24px"> </span>
                &ensp;<span class="is-bold" style="font-size: 20px">Diastolic</span>
              </div>
              <div class="row col-12 mt-2 flex-column">
                <span class="is-bold">
                  123mm Hg
                </span>
                <span>
                    123 mm Hg on the last test
                </span>
              </div>


            </div>

            <div class="card-measurement card mr-2 col-4">
              <div>
                <span class="fa fa-heart-o" style="font-weight: bold; font-size: 24px"> </span>
                &ensp;<span class="is-bold" style="font-size: 20px">Heart Rate</span>
              </div>
              <div class="row col-12 mt-2 flex-column">
                <span class="is-bold">
                  123mm Hg
                </span>
                <span>
                    123 mm Hg on the last test
                </span>
              </div>


            </div>


          </div>
        </div>
      </div>
      <button @click="generatePDF">Generate PDF</button>
    </div>-->
  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs.vue";
//import html2pdf from 'html2pdf.js';

export default {
  name: "index",
  components: { Breadcrumbs },
  methods: {
    handleRedirect: function(url) {
      window.open(url);
    },
    generatePDF: function() {
      const element = document.getElementById('reportContainer');

      // Set options for pdf generation (optional)
      const options = {
        margin: 10,
        filename: 'health_report.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };

      // Call html2pdf function with the element and options
      html2pdf(element, options);
    }
  }
};
</script>

<style scoped lang="scss">

.card {
  padding: 12px;
  border: 2px solid rgba(123, 125, 123, 0.77);
  border-radius: 12px;
  max-width: 6.4cm;
}

.card-measurement {
  max-width: 6.3cm;
}

.black-h4 {
  color: #282828;
  font-weight: bold;
}

.bio-params {
  background: #dcdcdc;
  margin-left: 0px !important;
}

#reportContainer {
  width: 100%;
  max-width: 21cm; /* A4 width */
  margin: 0 auto; /* Center the content on the page */
  background-color: white;
}
</style>
